import { useEffect, useState } from 'react'

import { useQueryClient } from '@tanstack/react-query'

import { QueryKeys } from '@/app/_utils/react-query'

import { PLPPages, PLPSlug } from '../types'

interface Params {
    page: PLPPages
    slug?: PLPSlug
}

export default function useBasicMetasInitialLoading({ page, slug }: Params) {
    const [isLoading, setIsLoading] = useState(true)
    const [shouldSendRequest, setShouldSendRequest] = useState(true)

    const queryClient = useQueryClient()

    useEffect(() => {
        const init = async () => {
            if (!shouldSendRequest) return

            if (page !== PLPPages.Search) {
                await queryClient.refetchQueries({ queryKey: QueryKeys.PLP.BasicMeta(page, slug) })
            }

            setShouldSendRequest(false)

            setIsLoading(false)
        }

        init()
    }, [queryClient, shouldSendRequest, page, slug])

    return isLoading
}
